import Status from 'clarks/components/ivu-table/status'

let forms = {
   filter_coupons: {
      icon: 'fa fa-university',
      title: 'Search Account',
      subtitle: 'Provide Account Details',
      forms: [
         { type: "datepicker", form_type: "daterange", format: "dd-MM-yyyy", placement: "bottom-end", class: "col-md-6 col-lg-5 col-xl-4", validation: "required", placeholder: "Filter Vouchers by Date", model: "date", label: "Date",hide_label: true },
         { type: 'button', btnClass: 'btn-long btn-primary', class: 'col-md-3 col-lg-2', model: 'submit', label: 'Search'}
      ]
   },
}

let tables = {
   referal_reports: {
      props: {
         icon: 'fa fa-database',
         title: 'Referal Reports',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ['referee_email', 'customer_email', 'customer_names', 'redemption_code', ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { title: "Customer Names", key: "customer_names", minWidth: 250},
            { title: "Customer Email", key: "customer_email", minWidth: 250},
            // { title: "Redemption Code", slot: "redemption_code", width: 200, align: 'center'},
            { title: "Discount", slot: "discount", minWidth: 200, align: 'right' },
            { title: "Is Redeemed", slot: "is_redeemed", width: 200 },
            { title: "Redeemed At", slot: "redeemed_at", width: 200 },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
            { type: 'menu', title: 'View Customer', event: 'view:customer', icon: 'fa-user', allow_multiple: false },
         ]
      },
   },
   promotion_coupon_redemption: {
      props: {
         icon: 'fa fa-gift',
         title: 'Promotion Coupon Redemption',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ['code', 'redemption_code', 'customer_id', 'discount', 'redeemed_at', ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { title: "Code", key: "code", },
            { title: "Redemption Code", slot: "redemption_code", },
            { title: "Customer Id", key: "customer_id", },
            { title: "Discount", slot: "discount", minWidth: 200, align: 'right'},
            { title: "Redeemed At", slot: "redeemed_at", },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
         ]
      },
   },
   coupon: {
      props: {
         icon: 'fa fa-donate',
         title: 'Coupon',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ['code', 'redemption_code', 'customer_id', 'discount', ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { title: "Redemption Code", slot: "redemption_code", width: 200, align: 'center'},
            { title: "Customer Id", key: "customer_id", },
            { title: "Discount", slot: "discount", minWidth: 200, align: 'right' },
            { title: "Is Redeemed", slot: "is_redeemed", },
            { title: "Expires At", slot: "valid_until", },
            { title: "Redeemed At", slot: "redeemed_at", },

         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
         ]
      },
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}